import {Component, OnInit, ViewChild, Input, Output, EventEmitter} from '@angular/core';
import {Config} from "../../../environments/environment";
import {UploadService} from "../../shared/services/http/upload.service";
import {NotificationsService} from "angular2-notifications";

@Component({
  selector: 'app-file-import',
  templateUrl: './file-import.component.html',
  styleUrls: ['./file-import.component.css']
})
export class FileImportComponent implements OnInit {

  @ViewChild("fileInput") fileInput;
  isImporting: boolean = false;

  @Input() title: string;
  @Input() private uploadPath: string;

  @Output() private success: EventEmitter<any> = new EventEmitter();
  @Output() private fail: EventEmitter<any> = new EventEmitter();

  constructor(private uploadService: UploadService,
              private notificationService: NotificationsService) {
  }

  uploadFile() {
    let kml = this.fileInput.nativeElement;
    if (kml.files && kml.files[0]) {
      this.isImporting = true;
      let file = kml.files[0];
      this.uploadService.upload(Config.baseUrl + this.uploadPath, "import", file).subscribe(response => this.success.emit(response),
        (error) => {
          this.fail.emit(error);
          this.isImporting = false;
        }, () => this.isImporting = false
      );
    }
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/settings/file-import/file-import.component.ts